<template>
  <div>
  <header class="bar bar-nav">
    <router-link class="button button-link button-nav pull-left" :to="{ name: 'home'}">
      <span class="icon icon-left"></span>
      返回首页
    </router-link>
  </header>


    <div class="content">
      <transition name="fade">
      <div class="card">
        <div class="card-content">
          <div class="card-content-inner">
            <span class="icon icon-gift" style="color: #c82829; margin-left: 40%"> 下单成功</span></div>
        </div>
      </div>
      </transition>
      <merchdata :merchList="recomPproducts" :description="description"></merchdata>
    </div>
    <div class="modal-overlay modal-overlay-visible" v-if="ifShowInstruction">
      <div class="lottery-background">
        <img @click="getCouponForSelf" src="/emktResources/resocurces/img/promotion/coupon-self.png" style="position: absolute;width: 105px;top: 400px;left: 50px;">
        <img @click="getCouponForFriend" src="/emktResources/resocurces/img/promotion/coupon-gift.png" style="position: absolute;width: 105px;top: 400px;right: 50px;">
        <img @click="ifShowInstruction = false" src="/emktResources/resocurces/img/promotion/lottery-close.png" style="position: absolute;width: 28px;left: 260px;top: 70px;">
        <div class="lottery-discount" v-if="promotions618Used && promotions618Used.length > 0">
          <div v-for="pro in promotions618Used">
            <div v-if="promotions618Used.length === 1" style="line-height: 10px;opacity: 0;">折扣券</div>
            <div v-if="pro.categoryId === 20">定制产品<span style="font-size: 20px;">{{pro.discount}}</span>折</div>
            <div v-else>现货及质粒产品<span style="font-size: 20px;">{{pro.discount}}</span>折</div>
          </div>
          <div style="transform: scale(0.8);color: #424242;">使用截止日期2020.7.18</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import {mapMutations, mapState, mapGetters} from 'vuex'
  import merchdata from '../../../components/MerchandiseList.vue'
  import Emkt from '../../../emkt'
//  import Clipboard from 'clipboard'
  export default {
    mounted () {
      this.$nextTick(function () {
//        if (this.order.lotteryURL) {
        this.getActivity()
//        }
      })
    },
    created () {
      var _this = this
      $.showPreloader('正在查询活动信息')
      _this.gcapi('retrieveMyOrder').then((response) => {
        console.log('retrieveMyOrder', response)
        _this.MYORDER_UPDATE(response.body.result)
        _this.showLottery()
      })
    },
    components: {
      merchdata
    },
    data () {
      return {
        order: this.$route.query.BOrders[0],
        recomPproducts: this.emkt.getLocalStorage('EmktAllRecommends'),
        description: '为你推荐',
        ifShowInstruction: false,
        promotions618Used: [],
        ifIsMonthlyFirstOrder: false
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    },
    computed: {
      ...mapState([
        'sessionInfo', 'myOrder', 'showLotteryAlready'
      ]),
      ...mapGetters([
        'hasLogin', 'customerName'
      ]),
      mobile () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.mobile
      },
      enterpriseName () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.enterpriseName
      },
      customerNo () {
        return this.sessionInfo && this.sessionInfo.customerInfo && this.sessionInfo.customerInfo.customerNo
      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'MYORDER_UPDATE'
      ]),
      getActivity () {
        // let _this = this
        // _this.gcapi('getSuccessPayData').then(function (response) {
        //   var successdata = JSON.parse(response.body.result)
        //   var order = _this.$route.query.order.merchandises
        //   var isshowbox = false
        //   var num = 0
        //   if (successdata.availableFlag === 1) {
        //     if (successdata.total === 0) {
        //       if (successdata.category.length > 0) {
        //         for (var n = 0; n < successdata.category.length; n++) {
        //           num = 0
        //           for (var m = 0; m < order.length; m++) {
        //             if (order[m].discountPrice === 0 && order[m].merchandiseDetailForClient.categoryId === successdata.category[n]) {
        //               num = num + order[m].quantity
        //             }
        //           }
        //           if (num >= successdata.num) {
        //             isshowbox = true
        //             break
        //           }
        //         }
        //       } else {
        //         num = 0
        //         for (var i = 0; i < order.length; i++) {
        //           if (order[i].discountPrice === 0) {
        //             num = num + order[i].quantity
        //           }
        //         }
        //         if (num >= successdata.num) {
        //           isshowbox = true
        //         }
        //       }
        //     } else {
        //       if (successdata.category.length > 0) {
        //         num = 0
        //         for (var o = 0; o < successdata.category.length; o++) {
        //           for (var p = 0; p < order.length; p++) {
        //             if (order[p].discountPrice === 0 && order[p].merchandiseDetailForClient.categoryId === successdata.category[0]) {
        //               num = num + order[p].quantity
        //             }
        //           }
        //         }
        //         if (num >= successdata.num) {
        //           isshowbox = true
        //         }
        //       } else {
        //         num = 0
        //         for (var r = 0; r < order.length; r++) {
        //           if (order[r].discountPrice === 0) {
        //             num = num + order[r].quantity
        //           }
        //         }
        //         if (num >= successdata.num) {
        //           isshowbox = true
        //         }
        //       }
        //     }
        //   }
        //   if (isshowbox) {
        //     let url = successdata.url
        //     $.modal({
        //       text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/successshow.jpg"></div>',
        //       buttons: [{
        //         text: '关闭'
        //       }],
        //       onClick: function () {
        //         $.modal({
        //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
        //           buttons: [{
        //             text: '确定放弃',
        //             onClick: function () {
        //               _this.getLotteryChance()
        //             }
        //           }, {
        //             text: '返回抽奖',
        //             onClick: function () {
        //               _this.getLotteryChance()
        //             }
        //           }]
        //         })
        //       }
        //     })
        //     $('#lottery').click(function () {
        //       window.open(url)
        //       $.closeModal()
        //     })
        //   }
        // })
//        this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
//          if (res.body.result) {
//            let url = res.body.result
//            $.modal({
//              text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
//              buttons: [{
//                text: '关闭'
//              }],
//              onClick: function () {
//                $.modal({
//                  text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
//                  buttons: [{
//                    text: '确定放弃',
//                    onClick: function () {
//                      _this.getLotteryChance()
//                    }
//                  }, {
//                    text: '返回抽奖',
//                    onClick: function () {
//                      _this.getLotteryChance()
//                    }
//                  }]
//                })
//              }
//            })
//            $('#lottery').click(function () {
//              window.open(url)
//              $.closeModal()
//            })
//          }
//        })
//         if (_this.$route.query.order.totalPrice > 3000) {
//           this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
//             if (res.body.result) {
//               let url = res.body.result
//               $.modal({
//                 text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
//                 buttons: [{
//                   text: '关闭'
//                 }],
//                 onClick: function () {
//                   $.modal({
//                     text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
//                     buttons: [{
//                       text: '确定放弃',
//                       onClick: function () {
//                         _this.getLotteryChance()
//                       }
//                     }, {
//                       text: '返回抽奖',
//                       onClick: function () {
//                         _this.getLotteryChance()
//                       }
//                     }]
//                   })
//                 }
//               })
//               $('#lottery').click(function () {
//                 window.open(url)
//                 $.closeModal()
//               })
//             }
//           })
//         }
//        if (this.myOrder && ((this.myOrder.completeOrders.length + this.myOrder.waitDeliverOrders.length + this.myOrder.finishedOrders.length) === 0)) {
//          this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
//            if (res.body.result) {
//              let url = res.body.result
//              $.modal({
//                text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></div>',
//                buttons: [{
//                  text: '关闭'
//                }],
//                onClick: function () {
//                  $.modal({
//                    text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
//                    buttons: [{
//                      text: '确定放弃',
//                      onClick: function () {
//                        _this.getLotteryChance()
//                      }
//                    }, {
//                      text: '返回抽奖',
//                      onClick: function () {
//                        _this.getLotteryChance()
//                      }
//                    }]
//                  })
//                }
//              })
//              $('#lottery').click(function () {
//                window.open(url)
//                $.closeModal()
//              })
//            }
//          })
//        }
//        if (this.myOrder && ((this.myOrder.completeOrders.length + this.myOrder.waitDeliverOrders.length + this.myOrder.finishedOrders.length) === 0)) {
//          $.modal({
//            text: '<div id="lottery"><img style="width: 12rem;height: 20rem;" src="/static/desc/img/song_register.jpg"></div>',
//            buttons: [{
//              text: '关闭'
//            }],
//            onClick: function () {
//              $.modal({
//                text: '首单奖励',
//                buttons: [{
//                  text: '已查看'
//                }]
//              })
//            }
//          })
//          $('#lottery').click(function () {
//            $.closeModal()
//          })
//        }
      },
      showLottery () {
        // 是否参与抽奖，刷新后不获取抽奖信息
        const paidOrder = this.$route.query.order
        if (!paidOrder || JSON.stringify(paidOrder) === '{}' || !paidOrder.merchandises) {
          return $.toast('暂无抽奖信息')
        }
        // 先判断是不是首单，此值需要传到优惠券领取页面
        this.ifIsMonthlyFirstOrder = this.isMonthlyFirstOrder()
        // 获取此订单中使用的618活动促销
        this.getPromotions618()
        if (this.promotions618Used && this.promotions618Used.length > 0) {
          $.hidePreloader()
          this.ifShowInstruction = true
        } else {
          this.gcapi('getAvailableLotteryChance', 'PaySuccessful').then((res) => {
            $.hidePreloader()
            if (res.body.result && res.body.result.length > 0) {
              let lotteryInfo = res.body.result[0]
              const url = lotteryInfo.url
              // 享受520促销，判断是否有抽奖记录
              // if (this.has520Promotion()) {
              //   const lotteryRecord = {
              //     guid: lotteryInfo.guid,
              //     customerNo: this.sessionInfo.customerInfo.customerNo
              //   }
              //   this.gcapi('checkedLotteryrecords', lotteryRecord).then(res => {
              //     if (!res.body.result) {
              //       $.toast('您已经抽过奖了')
              //       return
              //     }
              //     let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/a-178-show.png"></a></div>'
              //     const self = this
              //     $.modal({
              //       text: domText,
              //       buttons: [{
              //         text: '关闭'
              //       }],
              //       onClick: function () {
              //         $.modal({
              //           text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
              //           buttons: [{
              //             text: '确定放弃',
              //             onClick: function () {
              //             }
              //           }, {
              //             text: '<a href="' + url + '">返回抽奖</a>',
              //             onClick: () => {
              //               // 防止iphone手机报错，加@抑制报错信息
              //               self.gcapi('@submitLotteryrecords', lotteryRecord)
              //             }
              //           }]
              //         })
              //       }
              //     })
              //     $('#lottery').click(() => {
              //       self.gcapi('@submitLotteryrecords', lotteryRecord).then(res => {})
              //       $.closeModal()
              //     })
              //   })
              // } else {
              // 每个月首单抽奖，无需判断是否有抽奖记录
              if (!this.ifIsMonthlyFirstOrder) return $.toast('暂无抽奖信息')
              let domText = '<div id="lottery"><a href="' + url + '"><img style="width: 12rem;height: 20rem;" src="/emktResources/resocurces/img/promotion/show.jpg"></a></div>'
              // const self = this
              $.modal({
                text: domText,
                buttons: [{
                  text: '关闭'
                }],
                onClick: function () {
                  $.modal({
                    text: '亲，您确定放弃抽奖机会吗？中奖率百分之百哦～～～',
                    buttons: [{
                      text: '确定放弃',
                      onClick: function () {
                      }
                    }, {
                      text: '<a href="' + url + '">返回抽奖</a>',
                      onClick: () => {
                      }
                    }]
                  })
                }
              })
              // }
            }
          })
        }
      },
      isMonthlyFirstOrder () {
        if (!this.myOrder) return true
        let currentMonth = new Date().getMonth() + 1
        let currentYear = 2020
        if (![4, 5, 6].includes(currentMonth)) return true
        const waitDeliverAndFinishedOrders = [...this.myOrder.waitDeliverOrders, ...this.myOrder.finishedOrders]
        const orderSet = new Set()
        waitDeliverAndFinishedOrders.filter(order => new Date(order.payDT.replace(/-/g, '/')).getFullYear() === currentYear).forEach(order => {
          if (new Date(order.payDT.replace(/-/g, '/')).getMonth() + 1 === currentMonth) {
            orderSet.add(order.payDT.replace(/-/g, '/'))
          }
        })
        console.log('orderSet', orderSet)
        return orderSet.size === 1
      },
      // has520Promotion () {
      //   const paidOrder = this.$route.query.order
      //   if (!paidOrder || JSON.stringify(paidOrder) === '{}' || !paidOrder.merchandises) {
      //     return false
      //   }
      //   return paidOrder.merchandises.some(merchandise => {
      //     return merchandise && merchandise.perferPromotions && merchandise.perferPromotions.find(promotion => promotion && (promotion.promotionGuid.includes('-178') || promotion.promotionGuid.includes('-179')))
      //   })
      // },
      getPromotions618 () {
        const paidOrder = this.$route.query.order
        if (!paidOrder || JSON.stringify(paidOrder) === '{}' || !paidOrder.merchandises) {
          this.promotions618Used = []
        }
        const promotionGuids618 = Object.keys(Emkt.promotions618)
        const promotionsSet = new Set()
        paidOrder.merchandises.forEach(merchandise => {
          merchandise && merchandise.perferPromotions && merchandise.perferPromotions.forEach(promotion => {
            if (promotion && promotionGuids618.includes(promotion.promotionGuid)) {
              promotionsSet.add(promotion.promotionGuid)
            }
          })
        })
        this.promotions618Used = [...promotionsSet].sort().map(guid => Emkt.promotions618[guid])
        const guids = this.promotions618Used.map(pro => pro.guid).join(',')
        Emkt.setStoreItem('promotionGuids618Used', guids)
        console.log('promotions618Used', this.promotions618Used)
      },
      currentDayIs618 () {
        const promotions = Emkt.getLocalStorage('EmktPromotions')
        const pro = promotions && promotions.find(pro => pro.promotionGuid === 'promotion-20200602-186')
        const startDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second)
        const endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
        const now = new Date()
        console.log('currentDayIs618', now >= startDT && now <= endDT)
        return now >= startDT && now <= endDT
      },
      getCouponForSelf () {
        this.ifShowInstruction = false
        if (!this.hasLogin) {
          return alert('请先登录')
        }
        if (!this.promotions618Used || this.promotions618Used.length === 0) {
          return alert('无可领优惠券')
        }
        if (!this.customerNo || !this.mobile || !this.customerName || !this.enterpriseName) {
          return alert('个人信息不完整，请联系业务员')
        }
        const formCollectionActivity = {
          'customerNo': this.customerNo,
          'customerMobile': this.mobile,
          'customerName': this.customerName,
          'customerEnterpriseName': this.enterpriseName,
          'activityName': '618领取优惠券',
          'attachmentName': Emkt.getLocalStorage('promotionGuids618Used'),
          'additionalinfos': []
        }
        formCollectionActivity['additionalinfos'].push({
          'columnName': '券是否自用',
          'columnValue': '券自用'
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者电话号码',
          'columnValue': this.mobile
        })
        formCollectionActivity['additionalinfos'].push({
          'columnName': '持券者姓名',
          'columnValue': this.customerName
        })
        const formCollectionActivityList = []
        formCollectionActivityList.push(formCollectionActivity)
        this.gcapi('submitFormCollectionActivity', formCollectionActivityList).then((response) => {
          if (response.body.result === false) {
            return $.toast('提交失败')
          } else {
            // 领取优惠券后，清空订单中使用的618促销guids
            Emkt.setStoreItem('promotionGuids618Used', '')
            let result, text
            result = '领取成功'
            text = '折扣券将在3-5个工作日发放完毕'
            this.$router.replace({name: 'OperationResult', query: {result, text, 'showLottery': this.ifIsMonthlyFirstOrder}})
          }
        })
      },
      getCouponForFriend () {
        this.$router.replace({name: 'SearchContactWithoutDetail', query: {'showLottery': this.ifIsMonthlyFirstOrder}})
      }
    },
    addCartListForRecom (item, index) {
//        let pl = index
      let pl = '五周年'
      let pr = []
      pr.push(item)
      this.ADD_CART_LIST({pl, pr})
      $.toast('加入购物车成功！')
    }
  }
</script>

<style type="text/css" scoped>
  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .8s;
  }
  .fade-enter, .fade-leave-to {
    transform: translate3d(10rem, 1rem, 0);
    opacity: 0;
  }
  .modal modal-in {
    margin-top: -266px;
  }
  .lottery-background {
    background-image: url('/emktResources/resocurces/img/promotion/lottery-background.png');
    background-size: 100% 100%;
    width: 320px;
    height: 568px;
    margin: 0 auto;
    position: relative;
  }
  .lottery-discount {
    position: absolute;
    width: 170px;
    height: 70px;
    top: 310px;
    left: 75px;
    font-size: 14px;
    text-align: center;
    color: #DF4608;
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// successPay.vue?2331c3fc